// Initial-only runtime auto-loader for authored `.luis` sources.
// Legacy loader exports stay available but no longer watch DOM mutations.
import { compileFromDom } from './dom-compile'
import { emitLentyLog } from '@lentystyle/guard/shared'

const AUTO_FLAG = '__lentystyle_auto_loader_init__'

type LoaderOptions = {
  watch?: boolean
  force?: boolean
}

// Initialize one initial compile and return a no-op disposer for compatibility.
export function initLuisStylesheetAutoLoader(options: LoaderOptions = {}): () => void {
  if (!isBrowser()) {
    return () => undefined
  }

  void compileFromDom({ force: options.force }).catch((error) => {
    emitLentyLog('RUN0007', {}, { error })
  })
  return () => undefined
}

// Auto-start one initial compile once the document is ready in browser environments.
export function autoInitLuisStylesheetLoader(): void {
  if (!isBrowser()) {
    return
  }

  const win = window as Window & { [AUTO_FLAG]?: boolean }
  if (win[AUTO_FLAG]) {
    return
  }
  win[AUTO_FLAG] = true

  const start = (): void => {
    initLuisStylesheetAutoLoader()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true })
  } else {
    start()
  }
}

function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined'
}
